import { render, staticRenderFns } from "./_.vue?vue&type=template&id=24443a04&"
import script from "./_.vue?vue&type=script&lang=js&"
export * from "./_.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductPanel: require('/opt/build/repo/storefront/components/molecules/Product/ProductPanel.vue').default,ProductData: require('/opt/build/repo/storefront/components/molecules/Product/ProductData.js').default,HeroAnimation: require('/opt/build/repo/storefront/components/molecules/Hero/HeroAnimation.vue').default,ContentLoop: require('/opt/build/repo/storefront/components/organisms/ContentLoop.vue').default})
